import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import Text from '../../components/theme/text/Text';
import { useTranslation } from 'react-i18next';
import { selectAuthStatus, UserState } from "../../newapi/user/authentication/authSlice";
import { useSelector } from "react-redux";


const ShopifySetup = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const authStatus = useSelector(selectAuthStatus);

    useEffect(() => {
        const shop = searchParams.get('shop');
        const code = searchParams.get('code');

        if (shop && code) {
            // Store in cookies with 1 hour expiration
            const expires = new Date();
            expires.setTime(expires.getTime() + (60 * 60 * 1000)); // 1 hour

            localStorage.setItem("shopify_installation_shop", shop);
            localStorage.setItem("shopify_installation_code", code);
            localStorage.setItem("shopify_installation_expires", expires.toUTCString());

            if (authStatus === UserState.LOGGED_IN) {
                // Store the intended redirect URL in a cookie as well for post-login redirect
                const redirectUrl = `/relation/integrations/saleschannels?type=shopify&shop=${encodeURIComponent(shop)}&code=${encodeURIComponent(code)}`;
                navigate(redirectUrl);
            } else {
                navigate('/login');
            }
        } else {
            // Missing parameters, redirect to error or login
            navigate('/login');
        }
    }, [searchParams, navigate]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                gap: 2
            }}
        >
            <CircularProgress />
            <Text>{t('setting_up_shopify_integration')}</Text>
        </Box>
    );
};

export default ShopifySetup; 